export class DenteArea {
    constructor(
        public codigo?: string,
        public descricao?: string
        ){}
}


// WEBPACK FOOTER //
// ./src/app/components/base/vo/dente-area.ts